import {Injectable} from '@angular/core';
import Cookies from 'js-cookie';

const XSRF_COOKIE_POSTFIX = '_process_manager_xsrf';

@Injectable({
  providedIn: "root"
})
export class XsrfTokenReader {
  getToken(domain: string): string {
    return domain && Cookies.get(domain + XSRF_COOKIE_POSTFIX);
  }
}
